import { IlogisticServiceDetails } from './services';

export enum INCIDENT_MODES {
  CREATE = 'create',
  CLOSE = 'close'
}

export enum INCIDENT_SOURCE_REFERENCE_ID {
  LOGISTIC_SERVICE = 1,
  ORDER = 2,
  SHIPMENT = 3
}

export enum INCIDENT_TYPE_ID {
  ATTEMPTS = 1,
  BLOCKING = 2,
  INFORMATIVE = 3,
  CANCELLED = 4
}

export const CLOSABLE_INCIDENT_TYPES: INCIDENT_TYPE_ID[] = [
  INCIDENT_TYPE_ID.BLOCKING,
  INCIDENT_TYPE_ID.CANCELLED,
  INCIDENT_TYPE_ID.ATTEMPTS
];

export enum INCIDENT_STATUS_ID {
  OPEN = 1,
  CLOSED = 3
}

export const INCIDENT_REASON_TYPE_LABELS: Record<string, string> = {
  bloqueantes: 'Reportes bloqueantes',
  informativo: 'Reportes informativos o de avance',
  intentos: 'Reportes de entrega/recolección',
  cancelado: 'Reportes de cancelación'
};

export const ACTIVE_ONLY_INCIDENT_GROUPS = new Set(['intentos', 'cancelado']);

export const INCIDENT_REASON_CODES = {
  DELIVERY_ATTEMPT_1: 'R07',
  DELIVERY_ATTEMPT_2: 'R08',
  PICKUP_ATTEMPT_1: 'R09',
  PICKUP_ATTEMPT_2: 'R10',
  CANCEL_DELIVERY: 'R16',
  CANCEL_PICKUP: 'R24'
} as const;

export const CANCEL_INCIDENT_CODES: string[] = [
  INCIDENT_REASON_CODES.CANCEL_DELIVERY,
  INCIDENT_REASON_CODES.CANCEL_PICKUP
];

export const PREDECESSOR_CODES_BY_REASON: Record<string, string[]> = {
  [INCIDENT_REASON_CODES.DELIVERY_ATTEMPT_2]: [INCIDENT_REASON_CODES.DELIVERY_ATTEMPT_1],
  [INCIDENT_REASON_CODES.PICKUP_ATTEMPT_2]: [INCIDENT_REASON_CODES.PICKUP_ATTEMPT_1],
  [INCIDENT_REASON_CODES.CANCEL_DELIVERY]: [INCIDENT_REASON_CODES.DELIVERY_ATTEMPT_1, INCIDENT_REASON_CODES.DELIVERY_ATTEMPT_2],
  [INCIDENT_REASON_CODES.CANCEL_PICKUP]: [INCIDENT_REASON_CODES.PICKUP_ATTEMPT_1, INCIDENT_REASON_CODES.PICKUP_ATTEMPT_2]
};

export type TServiceIncidentSidebarMode = `${INCIDENT_MODES}`;

export interface IServiceIncidentSidebar {
  open: boolean;
  mode: TServiceIncidentSidebarMode;
  logisticServiceData: IlogisticServiceDetails;
  onClose: () => void;
  onActionCompleted?: () => void;
}

export interface IBordClosableIncident {
  uid: string;
  name: string;
  visibleId: string;
  createdAtLabel: string;
  createdBy: string;
}

export interface IIncidentReason {
  id: number;
  uuid: string;
  code: string;
  name: string;
  imageUrl?: string;
}

export interface IIncidentReasonsGroupedByType {
  id: number;
  uuid: string;
  name: string;
  reasons: IIncidentReason[];
}

export interface IIncidentReasonInLog extends IIncidentReason {
  incidentTypeId: number;
  createdAt: string;
}

export interface IIncidentLogUser {
  userId: number;
  firstName: string;
  lastName: string;
  personalId?: string;
  email: string;
  photoProfile?: string;
  phoneData?: {
    phone: string;
    phoneCode: string;
    phoneCountryId: number;
  };
}

export interface IIncidentActiveLog {
  id: number;
  incidentId: number;
  incidentStatusId: number;
  incidentReasonId: number;
  userNote?: string;
  attempt?: number;
  responsibleUserId: number;
  user?: IIncidentLogUser;
  createdAt: string;
  incidentReason: IIncidentReasonInLog;
}

export interface IOpenIncident {
  id: number;
  sourceId: number;
  incidentSourceReferenceId: number;
  createdAt: string;
  activeLog: IIncidentActiveLog;
}

export interface IIncidentsByTypeGroup {
  type: {
    id: number;
    uuid: string;
    name: string;
    createdAt: string;
  };
  incidents: IOpenIncident[];
}

export interface ICreateIncidentBody {
  sourceId: number;
  incidentSourceReferenceId: INCIDENT_SOURCE_REFERENCE_ID;
  incidentReasonId: number;
  userNote?: string;
  responsibleUserId?: number;
}

export interface ICreateIncidentResponse {
  id: number;
  sourceId: number;
  incidentSourceReferenceId: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface IAddIncidentLogBody {
  incidentReasonId: number;
  userNote?: string;
}

export interface IAddIncidentLogResponse {
  id: number;
  incidentId: number;
  incidentStatusId: number;
  incidentReasonId: number;
  userNote?: string;
  attempt?: number;
  responsibleUserId?: number;
  validUntil?: string;
  createdAt: string;
  deletedAt?: string;
}

export interface IIncidentDatesFormValue {
  pickupDateFrom?: string;
  pickupDateTo?: string;
  deliveryDateFrom?: string;
  deliveryDateTo?: string;
  trackingLink?: string;
  trackingCode?: string;
  providerName?: string;
}

export interface ICloseIncidentsBody {
  ids: number[];
  userNote?: string;
}

export interface ICloseIncidentsSucceeded {
  incidentId: number;
  logId: number;
}

export interface ICloseIncidentsFailed {
  incidentId: number;
  reason: string;
}

export interface ICloseIncidentsResponse {
  succeeded: ICloseIncidentsSucceeded[];
  failed: ICloseIncidentsFailed[];
}

export enum INCIDENT_HISTORY_EVENT_TYPE {
  OPENED = 'opened',
  ESCALATED = 'escalated',
  CANCELLED = 'cancelled',
  CLOSED = 'closed'
}

export interface IIncidentHistoryUser {
  userId: number;
  firstName: string;
  lastName: string;
}

export interface IIncidentHistoryEvent {
  type: `${INCIDENT_HISTORY_EVENT_TYPE}`;
  incidentId: number;
  reasonName: string;
  user: IIncidentHistoryUser | null;
  createdAt: string;
}
